import { Box, Container, Grid, Typography, useMediaQuery } from '@mui/material'
import { FileList, Icon } from 'components'
import { RichTextEditor } from 'components/richtTextEditor'
import { theme } from 'config'
import { observer } from 'mobx-react'
import { Step } from 'models'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { GridCard } from 'views/editor/gridCard'

export interface IGridCourseProps {
  step: Step,
}

export const GridCourse = observer((props: IGridCourseProps) => {
  const { step } = props;
  const { t }    = useTranslation();

  React.useEffect(() => {
    step.getGridSteps.forEach(s => s.loadDocuments());
  }, []);

  let gridCells: React.ReactNode[] = step.getGridSteps.map((s, idx) => (
    <Grid item xs={12} sm={6} key={s.id}>
      <GridCard course={step.course} step={s} idx={idx} />
    </Grid>
  ));

  // Maybe if length is odd, add element on every 3rd element
  // if(step.getGridSteps.length === 1) gridCells.unshift(<Grid key="stud-1" item xs={3} />);
  
  // if (step.getGridSteps.length % 2 !== 0) {
  //   for (let i = 2; i < gridCells.length; i += 3) {
  //     gridCells.splice(i, 0, <Grid key={`stud_${i}`} item xs={3} />);
  //   }
  // }

  // if(step.getGridSteps.length === 3) gridCells = [
  //   gridCells[0],
  //   gridCells[1],
  //   <Grid key="stud_2.5" item xs={3} />,
  //   gridCells[2],
  // ];


  return (
    <>
      <Grid xs={12} item>
        <Typography textAlign='center' mb={2} variant='h4'>
          {step.title}
        </Typography>
        <StyledRichTextEditor
          disable
          hideToolbar
          transparent
          readOnly = {true}
          value    = {step.getBlocks.join('')}
        />
      </Grid>
      <Container maxWidth='md'>
        <Grid container spacing={2}>
          {gridCells}
        </Grid>
      </Container>
      {step.getDocuments.length > 0 && (
        <Grid mt={theme.spacing(4)} item width='100%' xs={12} margin='auto'>
          <FileList files={step.getDocuments} />
        </Grid>
      )}
    </>
  );
});

const StyledRichTextEditor = styled(RichTextEditor)``;